/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { BaseQueryFn, FetchArgs, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ErrorNormalized } from '../../features/errors/models/error.model';
import { basePathHelper } from '../base-path.helper';
import { setAuthenticationStatus } from '../../features/authentication/authentication.slice';

const API_TAG_LIST = ['whats-on', 'event-session', 'appointment'] as const;
export type API_TAG = (typeof API_TAG_LIST)[number];
export interface ApiTagId {
    type: API_TAG,
    id: number
}

const { apiUrl } = basePathHelper;

const baseQuery = fetchBaseQuery({
    baseUrl: apiUrl,
    credentials: 'include',
    mode: 'cors',
});

const customBaseQuery: BaseQueryFn<string | FetchArgs, unknown, ErrorNormalized> = async (
    args,
    api,
    extraOptions,
) => {
    const { data, error, meta } = await baseQuery(args, api, extraOptions);

    if (!error) {
        return { data, meta };
    }

    let normalized: ErrorNormalized;
    if (!meta?.response) {
        normalized = {
            name: error.status.toString(),
            code: error.status.toString(),
            message: 'No response or unable to access response',
        };

        return { error: normalized, meta };
    }

    // there are two main alt cases
    // 400 bad requests; which are usually form validation errors
    // 401 Unauthenticated; authentication responses
    const errorData = error.data as any;
    console.log('error.data', error.data, typeof error.data);
    if (typeof errorData === 'string') {
        normalized = {
            code: meta.response.status.toString() || meta.response.statusText,
            message: errorData,
            validationErrors: undefined,
            data: undefined,
            stack: undefined,
        };
    } else {
        // assumes object type
        normalized = {
            code: errorData?.code || meta.response.status.toString() || meta.response.statusText,

            // err.json?.message - standard careerhub error message
            // err.response.statusText - human-friendly response based on response.status
            message: errorData?.message || meta.response.statusText,
            validationErrors: undefined,
            data: errorData?.data || undefined,
            stack: errorData?.stackTrace,
        };
    }

    // standard careerhub 400 response - validation errors
    if (meta.response.status === 400 && errorData && errorData.modelState) {
        Object.keys(errorData.modelState).forEach((key) => {
            const propertyName = key.substring(key.lastIndexOf('.') + 1);
            if (!normalized.validationErrors) {
                normalized.validationErrors = {};
            }
            normalized.validationErrors[propertyName] = errorData.modelState[key] as
            | string
            | string[];
        });
    }

    // fluent valiation type
    if (meta.response.status === 400 && Array.isArray(errorData?.errors)) {
        normalized.message = 'Validation errors';
        errorData.errors.forEach((x: any) => {
            if (x.property) {
                normalized.validationErrors![x.property] = x.message;
            }
        });
    }

    // unauthorized response
    if (meta.response.status === 401) {
        api.dispatch(setAuthenticationStatus({ status: 'unauthorized' }));
    }

    return { error: normalized, meta };
};

export const apiSlice = createApi({
    baseQuery: customBaseQuery,
    endpoints: () => ({}),
    tagTypes: API_TAG_LIST,
    keepUnusedDataFor: 60 * 5, // 5 minutes
});
